import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';

export default function initArrangementsSlider() {
    // Arrangements slider based on swiper
    let slidesPerView = 3;

    if (screen.width < 768) {
        slidesPerView = 1;
    }

    new Swiper('.arrangements-swiper', {
        slidesPerView,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slideClass: 'arrangement-slide',
        loopFillGroupWithBlank: false,
    });
}
